import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
export default {
  methods: {
    generatePdf(config) {
      this.loading = true;
      if (pdfMake.vfs == undefined) {
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }
      const {
        layerName = '',
        featureId = '',
        featureUrl = '',
        lastChangeDate = '',
        lastChangeUserName = '',
        firstChangeDate = '',
        firstChangeUserName = '',
        logoUrl = '',
        attributes = [],
      } = config;
      const attributesContent = [];
      for (const attrGroup of attributes) {
        attributesContent.push({ text: attrGroup.name, margin: [0, 10], style: 'objectExtrasTitle' });
        attributesContent.push({
          table: { widths: [200, '*'], body: attrGroup.elements.map(element => [element.name, element.value]) },
        });
      }
      const docDefinition = {
        pageMargins: [40, 80, 40, 60],
        header: {
          margin: [40, 20],
          columns: [{ image: 'logo', width: 40 }],
        },
        content: [
          {
            text: `${layerName}: ${featureId}`,
            style: 'header',
          },
          ...(lastChangeDate
            ? [
                {
                  text: `${this.$i18n.t('default.lastChange')}: ${lastChangeDate} ${
                    lastChangeUserName ? `(${lastChangeUserName})` : ''
                  }`,
                },
              ]
            : []),
          ...(firstChangeDate
            ? [
                {
                  text: `${this.$i18n.t('default.systemIntroduction')}: ${firstChangeDate} ${
                    firstChangeUserName ? `(${firstChangeUserName})` : ''
                  }`,
                },
              ]
            : []),
          {
            columns: [
              {
                width: 'auto',
                text: 'Link: ',
              },
              {
                width: 'auto',
                margin: [5, 0, 0, 0],
                text: `[${featureUrl}]`,
                link: featureUrl,
              },
            ],
            margin: [0, 0, 0, 20],
          },
          ...attributesContent,
        ],
        images: {
          logo: logoUrl,
        },
        styles: {
          header: {
            fontSize: 18,
            margin: [0, 0, 0, 20],
            bold: true,
          },
          objectExtrasTitle: {
            bold: true,
          },
          tableCol: {
            minWidth: 100,
          },
        },
      };
      pdfMake.createPdf(docDefinition).download('pdf.pdf');
      setTimeout(() => {
        this.loading = false;
      });
    },
  },
};
